import { useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import urls from "../../../urls";
import type { Paged } from "../../../utils/backend-types";
import type { StartPageOnboardingProgress } from "../StartPage.types";

function useStartPageOnboardingProgress(
  page: number,
  pageSize: number,
  projectId?: string,
  siteId?: number
) {
  return useQuery({
    queryKey: urls.startPage.onboardingProgress.key({
      page,
      pageSize,
      projectId,
      siteId
    }),
    queryFn: () =>
      fetchStartPageOnboardingProcess(page, pageSize, projectId, siteId)
  });
}

async function fetchStartPageOnboardingProcess(
  page: number,
  pageSize: number,
  projectId?: string,
  siteId?: number
) {
  const response = await apiWithoutCamelization.get<
    Paged<StartPageOnboardingProgress>
  >(
    urls.startPage.onboardingProgress.url({ page, pageSize, projectId, siteId })
  );
  return response.data;
}

export { useStartPageOnboardingProgress };
